import { truncate } from 'lodash'
import reactStringReplace from 'react-string-replace'

import { Emoji } from 'images'

import styles from './index.css'

const MAX_LINK_LENGTH = 45

export const truncateLink = (link) => truncate(link, { length: MAX_LINK_LENGTH })

export class Parser {
  constructor(content) {
    this.string = content == null ? '' : `${content}`
  }

  toString = () => this.string

  render() {
    let count = 0
    const rules = [
      // emails
      {
        regex: /([\S-]+@[\S-]+\.[\S-]+)/g,
        replacement: (match) => (
          <a key={match + count} href={`mailto:${match}`} title={match}>
            {truncateLink(match)}
          </a>
        ),
      },
      // link
      {
        regex: /(https?:\/\/\S+)/gi,
        replacement: (match) => {
          const isSweatBits = !!match.match(/sweatbits\.co/i)
          return (
            <a
              key={match + count}
              href={isSweatBits ? match.replace(/http:/i, 'https:') : match}
              rel="noreferrer"
              target={isSweatBits ? '_self' : '_blank'}
              title={match}
            >
              {truncateLink(match)}
            </a>
          )
        },
      },
      // link
      {
        regex: /(www\.\S+)/gi,
        replacement: (match) => {
          const isSweatBits = !!match.match(/sweatbits\.co/i)
          return (
            <a
              key={match + count}
              href={isSweatBits ? `https://${match.replace(/www\.sweatbits\.co/i, 'sweatbits.co')}` : `http://${match}`}
              rel="noreferrer"
              target={isSweatBits ? '_self' : '_blank'}
              title={match}
            >
              {truncateLink(match)}
            </a>
          )
        },
      },
      // link
      {
        regex: /(sweatbits\.co\S+)/gi,
        replacement: (match) => (
          <a key={match + count} href={`https://${match}`} target="_self" title={match}>
            {truncateLink(match)}
          </a>
        ),
      },
      // link
      {
        regex: /(sweatbits\.co)(\s+)/gim,
        replacement: (match) => (
          <a key={match + count} href={`https://${match}`} target="_self" title={match}>
            {truncateLink(match)}
          </a>
        ),
      },
      // emojis
      {
        regex: /(:[\w-+]+:)/g,
        replacement: (match) => <Emoji key={match + count} name={match} />,
      },
      // bold
      {
        regex: /\*(.*?)\*/g,
        replacement: (match) => <b key={match + count}>{match}</b>,
      },
      // emphasis
      {
        regex: /_(.*?)_/g,
        replacement: (match) => <em key={match + count}>{match}</em>,
      },
      // stroke
      {
        regex: /~(.*?)~/g,
        replacement: (match) => <del key={match + count}>{match}</del>,
      },
      // quote
      {
        regex: /"(.*?)"/g,
        replacement: (match) => <q key={match + count}>{match}</q>,
      },
      // quote
      {
        regex: /&quot;(.*?)&quot;/g,
        replacement: (match) => <q key={match + count}>{match}</q>,
      },
      // block code
      {
        regex: /```([^]*?)```/g,
        replacement: (match) => (
          <span key={match + count} className={styles.blockCode}>
            {match.trim()}
          </span>
        ),
      },
      // inline code
      {
        regex: /`(.*?)`/g,
        replacement: (match) => (
          <span key={match + count} className={styles.code}>
            {match}
          </span>
        ),
      },
      // mentions
      {
        regex: /(\s+@[\S-]+)/g,
        replacement: (...match) => (
          <span key={match + count} className={styles.mention}>
            {match}
          </span>
        ),
      },
      // mentions
      {
        regex: /^(@[\S-]+)/gm,
        replacement: (match) => (
          <span key={match + count} className={styles.mention}>
            {match}
          </span>
        ),
      },
      // hashtags
      {
        regex: /(\s+#[\S-]+)/g,
        replacement: (match) => (
          <span key={match + count} className={styles.hashtag}>
            {match}
          </span>
        ),
      },
      // hashtags
      {
        regex: /^(#[\S-]+)/gm,
        replacement: (match) => (
          <span key={match + count} className={styles.hashtag}>
            {match}
          </span>
        ),
      },
      // cite
      {
        regex: /^\s*>\s+(.*)/gm,
        replacement: (match) => (
          <cite key={match + count} className={styles.cite}>
            <div />
            <div>{match}</div>
          </cite>
        ),
      },
      // cite
      {
        regex: /^\s*&gt;\s+(.*)/gm,
        replacement: (match) => (
          <cite key={match + count} className={styles.cite}>
            <div />
            <div>{match}</div>
          </cite>
        ),
      },
    ]

    let text = [this.string]
    rules.forEach(({ regex, replacement }) => {
      text = reactStringReplace(text, regex, (match) => {
        count += 1
        return replacement(match)
      })
    })

    return text
  }
}

export default (...args) => new Parser(...args)
